<template>
    <div class="thanks-controller">
        <Component
            v-if="getComponentName"
            :is="getComponentName"
        />
    </div>
</template>

<script setup>
import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';

const {
    state: {
        thanks: {
            data: thanksData
        }
    },
    getters,
} = useStore();

const getPayData = computed(() => getters['thanks/getPayData']);

const getComponentName = computed(() => {
    const payData = getPayData?.value;

    if (
        payData?.psName === 'monoBank' &&
        payData?.status === 'ERROR'
    ) {
        // monobank error
        return 'MonobankRefusal';
    } else if (
        payData?.psName === 'monoBank' &&
        payData?.status === 'WAITING_FOR_CLIENT' ||
        payData?.status === 'ADDED'
    ) {
        // waiting for client payment
        return 'MonobankConfirmation';
    } else if (Object.keys(thanksData)?.length) {
        return 'Thanks';
    }

    return null;
})

onMounted(() => {
    console.log(getPayData.value);
})
</script>

<script>
import Thanks from "./Thanks";
import MonobankRefusal from "../Monobank/MonobankRefusal";
import MonobankConfirmation from "../Monobank/MonobankConfirmation";
export default {
    name: 'ThanksController',
    components: {
        Thanks,
        MonobankRefusal,
        MonobankConfirmation,
    }
}
</script>

<style lang="scss" scoped>
.thanks-controller{

}
</style>